export function hasLastName(name) {
  if (!name) return false;
  const words = name.trim().split(" ");
  return words.length > 1;
}
